function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

formFieldsBlur();

function formFieldsBlur() {
    const selectors = 'input, select, textarea';
    document.querySelectorAll(selectors).forEach((element) => {
        element.value != '' || element.tagName == 'SELECT' ? element.classList.add('compiled-field') : element.classList.remove('compiled-field');
        element.dispatchEvent(new Event('checkval'));

        element.addEventListener('blur', function() {
          this.classList.toggle('compiled-field', this.value.length > 0);
          this.dispatchEvent(new Event('checkval'));
        });

        element.addEventListener('checkval', e => {
            e.target.value !== "" || e.target.tagName == 'SELECT' ? e.target.classList.add('compiled-field') : e.target.classList.remove('compiled-field');
        });
    });
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
}

/* ZENDESK CHAT
* Hide chat on mobile
*/
function showZendChatOnScroll(element) {
    if(document.querySelector('iframe[data-product="web_widget"] + div')) {
        document.querySelector('iframe[data-product="web_widget"] + div').classList.add('hide');

        const handler = (entries) => {
        if (entries[0].isIntersecting) {
            document.querySelector('iframe[data-product="web_widget"] + div').classList.remove('hide');
        } else {
            document.querySelector('iframe[data-product="web_widget"] + div').classList.add('hide');
        }
        }

        const observer = new window.IntersectionObserver(handler);
        observer.observe(element);
    }
}

document.addEventListener('DOMContentLoaded', function() {
    let mql = window.matchMedia('(max-width:989px)');
    if (mql.matches) {
        setTimeout(function(){
            showZendChatOnScroll(document.querySelector('footer'));
        }, 5000);
    }
}, false);

//TODO: verificare se va abilitato (prevent zoom tutto il sito su iphone)
// prevent the default iphone zoom
// if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
//     window.document.addEventListener('touchmove', e => {
//         if(e.scale !== 1) {
//             e.preventDefault();
//         }
//     }, {passive: false});
// }

/*
 * Nunalie Functions
 *
 */
if ((typeof window.Nunalie) == 'undefined') {
    window.Nunalie = {};
}
if(STORE_IDENTIFIER == "IT"){
    /* HANDLE EMPTY REVIEW IN PDP */
    document.addEventListener('DOMContentLoaded', function() {
        // Select the node that will be observed for mutations
        let targetNode = null;
        if(document.querySelector(".skeepers_product__stars")){
            targetNode = document.querySelector(".skeepers_product__stars");
        }
        // Options for the observer (which mutations to observe)
        const config = { childList: true, subtree: true };
        // Callback function to execute when mutations are observed
        const callback = function(mutationList, observer) {
            // Use traditional 'for loops' for IE 11
            for(const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    document.querySelector(".product__verified-reviews.product__accordion.block ").classList.add("show");
                }
            }
        };
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        if(targetNode){
            observer.observe(targetNode, config);
        }
    });
}

let Nunalie = class {
    constructor() {
    }

    /**
     * Set Cookie value
     * @param {string} name           Cookie name.
     * @param {string} value          Cookie value.
     * @param {string} days           Cookie expiration days.
     * @param {string} domain         Cookie domain.
     */
    static createCookie(name,value,days, domain = '') {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        if(domain != ''){ domain = "domain="+domain+";"; }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    /**
     * Get Cookie value
     * @param {string} name           Cookie name.
     * @return {string}               Cookie value
     */
    static getCookieValue(name) {
        return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
    }

}
class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.previousValue = this.input.value;

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (this.previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);

    for (const key of formData.keys()) {
        const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

        if (regex.test(key)) {
            obj.properties = obj.properties || {};
            obj.properties[regex.exec(key)[2]] = formData.get(key);
        } else {
            obj[key] = formData.get(key);
        }
    }

    return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements  = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
        document.querySelectorAll('.modal__toggle').forEach(
            toggle => toggle.addEventListener('click', this.openSearchModal.bind(this))
        );

        document.addEventListener('scroll', () => {
            if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        });
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        /* accordion system */
        if(summaryElement.classList.contains('menu-drawer__menu-item')){
            const allSummaryElements  = this.querySelectorAll('summary.menu-drawer__menu-item');
            allSummaryElements.forEach(allSummaryElement => {
                const allDetailsElement = allSummaryElement.parentNode;
                const isOpen = allDetailsElement.hasAttribute('open');
                if(isOpen && detailsElement != allDetailsElement){
                    allDetailsElement.removeAttribute('open');
                    allDetailsElement.classList.remove('menu-opening');
                }
            });
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
        document.querySelector('#shopify-section-header').classList.add('menu-opening');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');
            this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });
            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
            document.querySelector('#shopify-section-header').classList.remove('menu-opening');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }

    openSearchModal(event) {
        if (event.currentTarget.hasAttribute('data-modal')) {
            const elementClass = event.currentTarget.getAttribute('data-modal');

            this.closeMenuDrawer(event);

            document.querySelector('.' + elementClass + ' summary').click();

            setTimeout(() => {
                document.querySelector('#snize-mobile-search-input').focus()
            }, 1000);
        }
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
        document.querySelector('#shopify-section-header').classList.add('menu-opening');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}
customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        const self = this;

        this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            this.hide.bind(this)
        );

        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        if (this.classList.contains('media-modal')) {
            this.addEventListener('click', (event) => {
                if (!event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
            });
        }

        window.addEventListener('dialog-close', function (event) {
            console.log(event);
            self.hide();
        });

        window.addEventListener('dialog-open', function (event) {
            if(self.getAttribute('id') == event.detail.opener.replace('#','')) {
              self.show(document.querySelector(event.detail.opener));
            }
        });
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);

class newsletterPopup extends ModalDialog {
    constructor() {
        super();
        this.button = this.querySelector('.button')
        this.form = this.querySelector('.newsletter--form');
        this.timeoutNP = false;

        // this.button.addEventListener('click', this.hide.bind(this))

        this.addEventListener('click', (event) => {
            if (event.target.nodeName === 'NEWSLETTER-POPUP') this.hide();
        });

        window.addEventListener('newsletter-close', (event) => {
            this.hide();
        });

        this.showPopup();
        this.initNewsletterForm();
    }

    hide() {
        Nunalie.createCookie('newsletterPopup','closed');
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
    } 

    showPopup () {
        const self = this;
        if (!Nunalie.getCookieValue('newsletterPopup')) {
            let observerElementID = false;
            let container = document.body;
            // Open popup after iubenda cookie solution
            if(window.Nunalie.iubenda) {
                observerElementID = 'iubenda-cs-banner';
            } else { // Open popup after banner-redirect
                observerElementID = !Nunalie.getCookieValue("countryN") ? 'banner-redirect' : false
                container = document.getElementById('banner-redirect');
            }

            if(observerElementID) {
                const dom_observer = new MutationObserver(function(mutationList) {
                    for (var mutation of mutationList) { // An array of all mutations that happened

                        if(mutation.addedNodes.length > 0) {
                            for (var child of mutation.addedNodes) { // An array of nodes added
                                let id = child.getAttribute('id');
                                if (id === observerElementID) {
                                    this.timeoutNP = setTimeout(() => {
                                        self.setAttribute('open', '');
                                    }, 10000);
                                    dom_observer.disconnect();
                                }
                            }
                        } else {
                            if(mutation.type == 'attributes' && mutation.attributeName == 'style' && mutation.oldValue == 'display:none') {
                                this.timeoutNP = setTimeout(() => {
                                    self.setAttribute('open', '');
                                }, 10000);
                                dom_observer.disconnect();
                            }
                        }
                    }
                });

                const config = { attributes: true, attributeFilter: ['style'], attributeOldValue: true, childList: true, characterData: true };
                dom_observer.observe(container, config);
            } else {
                self.setAttribute('open', '');
            }
        }
    }

    resetForm() {
        this.classList.remove('notification');
        this.hide();
        this.form.reset();
        const alert = this.form.querySelector('[data-alert="status"]');
        alert.innerHTML = '';
    }

    initNewsletterForm() {

        const inputs = this.form.querySelectorAll("[name]")
            self = this;

        if(window.location.href.indexOf("customer_posted=true") != -1){
            this.classList.add('notification');
            this.setAttribute('open', '');

            this.timeOut = setTimeout(function(){ self.hide(); }, 5000);
        }

        if(window.location.href.indexOf("challenge") != -1){
            if(localStorage.getItem('NF')) {
                const encrypted = CryptoJS.AES.decrypt(localStorage.getItem('NF'), 'nlNP');
                const decrypted = CryptoJS.enc.Utf8.stringify(encrypted);
                const savedData = JSON.parse(decrypted);

                Object.keys(savedData).forEach(key => {
                    console.log(key + ' ' + savedData[key] );
                    if(this.form.querySelector("[name='" + key + "']")) {
                        let formInput = this.form.querySelector("[name='" + key + "']");

                        if(formInput.getAttribute('type') === 'checkbox') {
                            savedData[key] == 'on' ? formInput.checked = true : formInput.checked = false;
                        } else {
                            formInput.value = savedData[key];
                        }
                    }
                });
            }
        } else {
            localStorage.removeItem('NF');
            this.form.reset();
        }

        // Submit data via Fetch
        this.form.addEventListener('validation-submit', function (e) {
            e.preventDefault();

            let formData = formToJSON(inputs);
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(formData), 'nlNP').toString();

            localStorage.setItem('NF', encrypted);
            return true;
        });
    }

    initNewsletterFormAjax() {

        const action = 'https://' + Shopify.shop + this.form.getAttribute("data-action"),
            alert = this.form.querySelector('[data-alert="status"]'),
            inputs = this.form.querySelectorAll("[name]")
            self = this;


        // Submit data via Fetch
        this.form.addEventListener('validation-submit', function (e) {
            this.classList.add('notification');

            fetch(action, {...fetchConfig(),
                mode: 'no-cors',
                body: getUrlString(formToJSON(inputs))
            }).then(function (response) {
                self.classList.add('notification');
                alert.className = "alert alert-success";
                alert.innerHTML = window.formString.newsletter_success;
                setTimeout(() => { self.resetForm() }, 3000);
            }).catch(function (error) {
                self.classList.add('notification');
                alert.className = "alert alert-danger";
                alert.innerHTML = window.formString.post_error;
            });
        });
    }
}
customElements.define('newsletter-popup', newsletterPopup);


/** Back in stock
* custom notify-popup
* https://help.backinstock.org/article/2303-javascript-api
**/
class notifyMePopup extends ModalDialog {
    constructor() {
        super();
        this.button = this.querySelector('#notify_me');
        this.privacyField = this.querySelector('.notify-me__privacy');
        this.privacy = this.querySelector('#notify__privacy');
        this.email = this.querySelector('#notify_email');
        this.select = this.querySelector('#notify_variant');
        this.dialogContainer = this.querySelector('.dialog__container');

        this.addEvents();
    }

    addEvents() {
      const self = this;
      this.button.addEventListener('click', function(event) {
        event.preventDefault();

        self.classList.remove('notification');

        if(self.privacy.checked) {
          self.privacyField.classList.remove('field--error');

            const email = self.email.value,
            productId = self.select.getAttribute('data-product'),
            variantId = self.select.value;

            // Back in stock API
            BIS.create(email, variantId, productId).then(self.notificationCallback);

            self.classList.add('notification');
            setTimeout(() => { self.hide() }, 3000);

        } else {
          self.privacyField.classList.add('field--error');
        }
      })
    }

    notificationCallback(data) {
      let msg = '';
      const dialogNotification = document.querySelector('.dialog__notification');
      if (data.status == 'OK') {
        msg = data.message; // just show the success message
        dialogNotification.className = "dialog__notification alert-success";
      } else { // it was an error
        for (var k in data.errors) {
            // collect all the error messages into a string
           msg += (data.errors[k].join());
         }
         dialogNotification.className = "dialog__notification alert-danger";
      }

      const messageWrapper = document.createElement('p');
      messageWrapper.innerHTML = msg;

      dialogNotification.appendChild(messageWrapper);
      dialogNotification.style.display = 'block';
    }
}
customElements.define('notifyme-popup', notifyMePopup);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent() {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('ul');
        this.sliderItems = this.querySelectorAll('li');
        this.pageCount = this.querySelectorAll('.slider-counter--current');
        this.pageTotal = this.querySelectorAll('.slider-counter--total');
        this.prevButton = this.querySelectorAll('button[name="previous"]');
        this.nextButton = this.querySelectorAll('button[name="next"]');
        this.progressBar = this.querySelector('.slider__progress-bar .bar') || this.querySelector('.bar');

        if (!this.slider || this.nextButton.length === 0) return;

        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.customEventObserve();

        this.nextButtonArray = Array.from(this.nextButton).forEach(element => element.addEventListener('click', this.onButtonClick.bind(this)));
        this.prevButtonArray = Array.from(this.prevButton).forEach(element => element.addEventListener('click', this.onButtonClick.bind(this)));
        if (this.progressBar) this.progressBar.addEventListener('click', this.onBarClick.bind(this));

    }

    customEventObserve() {
        const self = this;
        window.addEventListener('slider-refresh', function () {
            self.slider = self.querySelector('ul');
            self.sliderItems = self.querySelectorAll('li');
            self.progressBar = self.querySelector('.slider__progress-bar .bar') || self.querySelector('.bar');
            self.initPages();
        });
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
        if (this.sliderItemsToShow.length === 0) return;
        this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
        if (this.progressBar) this.initProgressBar();
    }

    initProgressBar() {
        const total = Math.max(1, this.totalPages || 1);
        this.progressBar.querySelector('.progress').style.width = (100 / total) + '%';
    }

    update() {
        if (!this.slider || !this.sliderLastItem) return;

        const slideWidth = this.sliderLastItem.clientWidth || 1;
        this.currentPage = Math.round(this.slider.scrollLeft / slideWidth) + 1;

        if (this.pageCount && this.pageCount.length && this.pageTotal && this.pageTotal.length) {
            Array.from(this.pageCount).forEach((element) => (element.textContent = this.currentPage));
            Array.from(this.pageTotal).forEach((element) => (element.textContent = this.totalPages));
        }

        if (this.progressBar) this.updateProgressBar();
    }

    onButtonClick(event) {
        event.preventDefault();
        let slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
        // If last item back to init
        if (this.currentPage >= this.totalPages) {
            slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }

    onBarClick(event) {
        const bar = event.currentTarget;
        const progress = bar.querySelector('.progress');

        let slideScrollPosition = event.offsetX >= progress.offsetWidth ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;

        // If last item back to init
        if (this.currentPage >= this.totalPages) {
            slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: slideScrollPosition
        });

        this.updateProgressBar(event);
    }

    updateProgressBar(event) {
        const progress = this.progressBar.querySelector('.progress');
        if (this.currentPage > this.totalPages) {
            progress.style.width = (100 * 1) / this.totalPages + '%';
        } else {
            progress.style.width = (100 * this.currentPage) / this.totalPages + '%';
        }
    }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
        this.shopsContainer = document.querySelector('.product__shops-availability') ? document.querySelector('.product__shops-availability') : false;
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();

        if (this.shopsContainer) {
            this.toggleAvailability();
            this.getShopsAvailability();
        }

        this.toggleAddButton(false, '', false);
        this.updatePickupAvailability();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        const newMedia = document.querySelector(
            `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        const parent = newMedia.parentElement;
        if (parent.firstChild == newMedia) return;
        modalContent.prepend(newMediaModal);
        parent.prepend(newMedia);
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (this.stickyHeader) {
            this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
        window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({ behavior: "smooth" }); });
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) destination.innerHTML = source.innerHTML;

                ['BantoaVisualDiscovery', 'BantoaVisualDiscoveryCta'].forEach((prefix) => {
                    const elementId = `${prefix}-${this.dataset.section}`;
                    const elementDestination = document.getElementById(elementId);
                    const elementSource = html.getElementById(elementId);

                    if (elementSource && elementDestination) {
                        elementDestination.innerHTML = elementSource.innerHTML;
                    }
                });

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, '');
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');

        if (!addButton) return;

        if (disable) {
            if(text) {
                addButton.classList.remove('button--primary');
                addButton.classList.add('button--secondary');
                addButton.setAttribute('disabled', true);
            }
            if (text) addButton.textContent = text;
        } else {

            addButton.removeAttribute('disabled');
            addButton.classList.remove('button--secondary');
            if (text) {
                addButton.classList.add('button--tertiary','button--with-icon','icon-message');
                addButton.textContent = text;
            } else {
                addButton.classList.remove('button--tertiary','button--with-icon','icon-message');
                addButton.classList.add('button--primary');
                addButton.textContent = window.variantStrings.addToCart;
            }
        }

        if (!modifyClass) return;
    }

    toggleAvailability() {
        const details = this.shopsContainer.querySelector('details');
        if (details.hasAttribute('open'))
            details.removeAttribute('open');

        details.removeAttribute('disabled');
    }

    getShopsAvailability() {
        this.shopsContainer.querySelector('details').setAttribute('disabled', true);

        if (this.currentVariant) {
            this.currentVariantSelected = this.getVariantMetafield().find((variant) => {
                return this.currentVariant.id === variant.id;
            });

            this.renderShopsAvailabilityInfo();
        }
    }

    renderShopsAvailabilityInfo() {
        const self = this;
        const shopsList = this.shopsContainer.querySelector('.list-shops');

        let unavailabilityMsg = shopsList.querySelector(".unavailabilityMsg");
        if(unavailabilityMsg) unavailabilityMsg.remove();

        this.shopsAvailable = 0;
        this.shopsContainer.querySelectorAll('.list-shops li[data-id]').forEach(function (item, index) {
            if (!self.currentVariantSelected.shops.includes(item.dataset.id)) {
                item.dataset.available = false;
                let spanTarget = item.querySelector('span.availability');
                if(spanTarget) spanTarget.innerText = window.variantStrings.unavailable;
            } else {
                self.shopsAvailable++;
                item.dataset.available = true;
                let spanTarget = item.querySelector('span.availability');
                if(spanTarget) spanTarget.innerText = window.variantStrings.available;
            }

            item.addEventListener('click', (event) => {
                const modal = document.querySelector( event.target.getAttribute('data-modal') );
                if (modal) modal.show(item);
            });
        });
        if(self.shopsAvailable == 0) {
            let listItem = document.createElement('li');
            listItem.classList.add("unavailabilityMsg");
            listItem.innerHTML = window.variantStrings.shops_unavailable;
            shopsList.appendChild(listItem);
        }
        this.toggleAvailability();

        // Filters shops by availability using checkboxes
        this.resetShopsFilters();
        this.filterShopsByAvailability();
    }

    resetShopsFilters() {
        const filterShopsCheckboxes = this.shopsContainer.querySelectorAll('.product__shops-availability-filter input');
        filterShopsCheckboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });
        const shops = this.shopsContainer.querySelectorAll('.list-shops li');
        shops.forEach((shop) => {
            shop.classList.remove('hidden');
        });
    }

    filterShopsByAvailability() {
        const filterShopsCheckboxes = this.shopsContainer.querySelectorAll('.product__shops-availability-filter input');
        filterShopsCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', (e) => {
                // Check the values of the filters
                let availableFilterChecked = false;
                let unavailableFilterChecked = false;

                filterShopsCheckboxes.forEach(checkbox => {
                    if (checkbox.checked) {
                        if (checkbox.name === 'available') availableFilterChecked = true;
                        if (checkbox.name === 'unavailable') unavailableFilterChecked = true;
                    }
                });

                // If both filters are checked, uncheck the other one
                if (availableFilterChecked && unavailableFilterChecked) {
                    filterShopsCheckboxes.forEach(checkbox => {
                        if (checkbox.name !== e.target.name) {
                            checkbox.checked = false;
                            // Update the variables
                            if (checkbox.name === 'available') availableFilterChecked = false;
                            if (checkbox.name === 'unavailable') unavailableFilterChecked = false;
                        }
                    });
                }

                /*
                * Conditions to show available (A) / unavailable (B) shops:
                    A OR (NOT A AND NOT B)
                    B OR (NOT A AND NOT B)
                */
                const showAvailableShops = availableFilterChecked || (!availableFilterChecked && !unavailableFilterChecked);
                const showUnavailableShops = unavailableFilterChecked || (!availableFilterChecked && !unavailableFilterChecked);

                // Show/hide shops based on filters
                const shops = this.shopsContainer.querySelectorAll('.list-shops li');
                shops.forEach((shop) => {
                    if (shop.dataset.available === 'true' && showAvailableShops) {
                        shop.classList.remove('hidden');
                    } else if (shop.dataset.available === 'false' && showUnavailableShops) {
                        shop.classList.remove('hidden');
                    } else {
                        shop.classList.add('hidden');
                    }
                });
            });
        });
    }

    getVariantMetafield() {
        this.variantMetafield = this.variantMetafield || JSON.parse(this.shopsContainer.querySelector('[type="application/json"]').textContent);
        return this.variantMetafield;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButton.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        return checked ? checked.value : null;
      });
    }
}
customElements.define('variant-radios', VariantRadios);

class VariantCustom extends VariantRadios {
    constructor() {
        super();
    }

    /**
     * Returns whether every visible (size) fieldset has a selected radio.
     * @returns {boolean}
     */
    hasSizeSelected() {
        const sizeFieldsets = Array.from(this.querySelectorAll('fieldset:not(.hidden)'));
        if (!sizeFieldsets.length) return true;

        return sizeFieldsets.every((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).some((radio) => radio.checked);
        });
    }

    /**
     * Syncs Bantoa Visual Discovery size attributes with the current size selection.
     */
    updateVisualDiscoveryAttributes() {
        const buttons = document.querySelectorAll('.card__visual-discovery[data-bantoa-visual-discovery]');
        const checkedSize = this.querySelector('fieldset:not(.hidden) input:checked');

        buttons.forEach((button) => {
            if (this.dataset.requireSizeSelection === 'true' && !checkedSize) {
                button.removeAttribute('data-vs-filter');
                button.removeAttribute('data-vs-showsizes');
                return;
            }

            if (checkedSize?.value) {
                button.setAttribute('data-vs-filter', JSON.stringify({ sizes: checkedSize.value }));
                button.setAttribute('data-vs-showsizes', 'true');
            }
        });
    }

    connectedCallback() {
        this.nosell = this.dataset.nosell;
        this.variantsInventory = JSON.parse(this.dataset.variants);
        this.quantityLimit = this.dataset.limit;

        this.updateOptions();
        this.updateMasterId();

        if (this.dataset.requireSizeSelection === 'true' && !this.hasSizeSelected()) {
            this.toggleAddButton(true, '', true);
            this.updateLabels();
        } else {
            this.updateAvailability();
            this.updateLabels();
        }

        this.mql = window.matchMedia('(min-width:1025px)');
        if (this.mql.matches) {
            this.triggerChange();
        }
        if (this.shopsContainer) {
            this.toggleAvailability();
            if (this.hasSizeSelected()) {
                this.getShopsAvailability();
            }
        }
        this.updateVisualDiscoveryAttributes();
        this.currentSelected = this.querySelector('.label__details .values')?.innerText;
    }

    onVariantChange() {
        VariantSelects.prototype.onVariantChange.call(this);
        this.updateAvailability();
        this.updateVisualDiscoveryAttributes();
    }

    triggerChange() {
        const self = this;
        const labels = this.querySelectorAll('.variant__label');

        labels.forEach(function (el, index) {
            el.addEventListener('mouseenter', function () {
                el.classList.toggle('highlight');
                self.selectedOptions[0] = this.innerText;
                self.currentVariantSelected = self.getVariantData().find((variant) => {
                    return !variant.options.map((option, index) => {
                        return self.selectedOptions[index] === option;
                    }).includes(false);
                });
                self.querySelector('.label__details .values').innerHTML = this.innerText;
                self.updateAvailability(el);
            });

            el.addEventListener('mouseleave', function () {
                el.classList.toggle('highlight');
                self.selectedOptions[0] = self.options[0];
                self.currentVariantSelected = self.currentVariant;
                self.querySelector('.label__details .values').innerHTML = self.currentSelected;
                self.updateAvailability(el);
            });
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
            return checked ? checked.value : null;
        });

        const sizeFieldset = this.querySelector('fieldset:not(.hidden)');
        const checkedSizeRadio = sizeFieldset?.querySelector('input:checked');
        const selectedVariant_id = checkedSizeRadio?.getAttribute('data-variant-id');

        this.currentSelected = checkedSizeRadio?.value ?? '';
        this.variantsInventory = this.variantsInventory || JSON.parse(this.dataset.variants);
        this.quantityLimit = this.quantityLimit || this.dataset.limit;

        const addButton = document.querySelector('button[name="add"]');
        const selectedVariantObj = this.variantsInventory.find((variant) => variant?.id && variant.id == selectedVariant_id);
        const jsonData = addButton.getAttribute('data-product-add');
        const gtmData = JSON.parse(jsonData);
        const colorOption = this.getAttribute('data-option-colorName').toLowerCase();
        const colorInput = this.querySelector('input[data-optionName="' + colorOption + '"]:checked');
        const variantColor = colorInput?.value ?? '';
        gtmData.variant = this.currentSelected + ' / ' + variantColor;
        if (selectedVariantObj) {
            gtmData.price = selectedVariantObj.price;
            gtmData.sku = selectedVariantObj.sku;
        }
        addButton.setAttribute('data-product-add', JSON.stringify(gtmData));

        this.updateSelectedOptions(fieldsets);
    }

    updateSelectedOptions(fieldsets) {
        this.selectedOptions = fieldsets.map((fieldset) => {
            const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
            return checked ? checked.value : null;
        });

        if (this.selectedOptions.includes(null)) {
            this.currentVariantSelected = null;
            return;
        }

        this.currentVariantSelected = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.selectedOptions[index] === option;
            }).includes(false);
        });
    }

    updateLabels() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset.hidden'));
        const color = fieldsets.map((fieldset) => {
            const checked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
            return checked ? checked.value : null;
        });

        this.AllOptions = document.querySelectorAll('fieldset:not(.hidden) input[type="radio"]');

        this.AllOptions.forEach((element) => {
            let arr = [element.value, color[0]];
            let current = this.getVariantData().find((variant) => {
                return !variant.options.map((option, index) => {
                    return arr[index] === option;
                }).includes(false);
            });
            if (!current) return;
            let variantQty = this.variantsInventory.find((variant) => {
                return current.id === variant.id;
            });
            if (!variantQty) return;
            !parseInt(variantQty.qty) > 0 || this.nosell == 'true' ? element.nextElementSibling.classList.add('sold-out') : '';
        });

    }

    updateAvailability(element) {
        if (!this.currentVariantSelected) {
            this.toggleAddButton(true, '', true);
            return;
        }

        const availabilityLabel = this.querySelector('.label__details .availability');
        const variantQty = this.variantsInventory.find((variant) => {
            return this.currentVariantSelected.id === variant.id;
        });
        if(typeof(element) == 'undefined') {
            element = document.querySelector('.product-form__input input[type="radio"]:checked + label');
        }

        const availableString = parseInt(variantQty.qty) > parseInt(this.quantityLimit) ? window.variantStrings.available : window.variantStrings.limited_qty
        const unavailableString = document.body.classList.contains('back-in-stock') ? window.variantStrings.unavailable : window.variantStrings.soldOut;
        if(this.currentVariantSelected.available && this.nosell != 'true' && availabilityLabel) {
            availabilityLabel.innerHTML = availableString;
            availabilityLabel.classList.remove('sold-out');
        }
        else{
            if(availabilityLabel) {
                availabilityLabel.innerHTML = unavailableString;
                availabilityLabel.classList.add('sold-out');
            }
        }
        // availabilityLabel.innerHTML = this.currentVariantSelected.available ? availableString : unavailableString;
        //this.currentVariantSelected.available ? availabilityLabel.classList.remove('sold-out') : availabilityLabel.classList.add('sold-out');
        if(!this.currentVariantSelected.available) {
            if (document.body.classList.contains('back-in-stock')) {
                this.toggleAddButton(false, window.variantStrings.notify_me, true);
            } else {
                this.toggleAddButton(true, unavailableString , true)
            }
        }else {
            this.toggleAddButton(false, '', true);
        }
    }
}
customElements.define('variant-custom', VariantCustom);

class FreeShippingInfoBar extends HTMLElement {
    constructor() {
        super();

        this.progressBar = this.querySelector('.progress-bar');
        this.textElement = this.querySelector('.info-text');
    }

    connectedCallback() { console.log("connectedCallback");
        this.progressBar.style.width = `0%`;
        setTimeout(() => {this.updateProgress()}, 150);

    }

    static get observedAttributes() {
        return ['data-cart-total'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-cart-total') {
            this.updateProgress();
        }
    }

    getThreshold() {
        return parseFloat(this.dataset.freeShippingThreshold);
    }

    getCartTotal() {
        return parseFloat(this.dataset.cartTotal);
    }

    getInfoText() {
        return this.dataset.infoText;
    }

    getSuccessText() {
        return this.dataset.successText;
    }

    getCurrency() {
        return this.dataset.storeCurrency;
    }

    updateProgress() {
        this.progressBar.style.width = `0%`;
        const threshold = this.getThreshold();
        const cartTotal = this.getCartTotal();
        const infoText = this.getInfoText();
        const successText = this.getSuccessText();
        const storeCurrency = this.getCurrency();

        if (!this.progressBar || !this.textElement ) return;

        const remaining = Math.max(0, threshold - cartTotal);
        const progress = Math.min(100, (cartTotal / threshold) * 100);

        this.progressBar.style.width = `${progress}%`;

        if (cartTotal >= threshold) {
            this.progressBar.classList.add('completed');
            this.textElement.textContent = successText;
        } else {
            const amountText = `<b class="amount">${remaining.toFixed(2)}</b>`;
            this.textElement.innerHTML = infoText.replace('[[difference]]', amountText + storeCurrency);
            this.progressBar.classList.remove('completed');
        }
    }
}

customElements.define('free-shipping-info-bar', FreeShippingInfoBar);